import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-waa-edit-row-col1',
  template: `
    <div>{{ internalId }}</div>
    <div class="font-12" *ngIf="checkValue">({{ checkValue }})</div>
  `
})
export class WaaEditRowCol1Component {
  @Input() internalId: string;
  @Input() checkValue: string;
}
